<template>
  <div class="login-container">
    <div class="login_header">
      <img class="logo" src="https://fscdn.zto.com/fs21/M00/F8/28/CgRRhWHL-KOAFgLgAACXfozlyIQ415.png" />
      <span class="app-name">{{ APP_TITLE }}</span>
    </div>
    <div
      class="login_bg"
      style="background-image: url('https://fscdn.zto.com/fs8/M01/10/8D/wKhBEF8ZAQKAXj9WAAGgN37-DRA413.png')"
    >
      <el-image class="img-ios" :src="iosImg" @click="handlePreview(iosImg)"></el-image>
      <el-image class="img-android" :src="androidImg" @click="handlePreview(androidImg)"></el-image>

      <div class="login_modal">
        <div class="login-form">
          <div class="login-content">
            <div class="tabs-nav">
              <div
                class="nav-item"
                :class="{ active: loginModel.mode === LoginMode.PASSWORD }"
                @click="changeLoginMode(LoginMode.PASSWORD)"
              >
                <span>密码登录</span>
              </div>
              <div
                class="nav-item"
                :class="{ active: loginModel.mode === LoginMode.SMS }"
                @click="changeLoginMode(LoginMode.SMS)"
              >
                <span>短信登录</span>
              </div>
            </div>
            <div v-if="loginModel.mode === LoginMode.PASSWORD" class="login-section">
              <div class="login-group">
                <el-input
                  :maxlength="11"
                  class="input"
                  clearable
                  v-model="loginModel.mobile"
                  size="large"
                  placeholder="请输入手机号"
                />
                <el-input
                  class="input"
                  v-model="loginModel.password"
                  show-password
                  clearable
                  size="large"
                  :maxlength="25"
                  placeholder="请输入密码"
                />
              </div>
            </div>
            <div v-if="loginModel.mode === LoginMode.SMS" class="login-section">
              <div class="login-group">
                <el-input
                  :maxlength="11"
                  class="input"
                  clearable
                  v-model="loginModel.mobile"
                  size="large"
                  placeholder="请输入手机号"
                />
                <div style="display: flex">
                  <el-input
                    :maxlength="6"
                    class="input"
                    clearable
                    v-model="loginModel.verifyCode"
                    size="large"
                    placeholder="请输入验证码"
                  />
                  <el-button
                    class="q-ml-md"
                    style="height: 40px"
                    @click="startVerify"
                    :disabled="verifyText === '获取验证码' ? false : true"
                  >
                    {{ verifyText }}
                  </el-button>
                </div>
              </div>
            </div>
            <div class="login-footer">
              <el-button class="login-btn" type="primary" size="large" @click="handleLogin">登录</el-button>
            </div>
          </div>
        </div>
      </div>
      <el-dialog v-model="dialogVisible" title="图片预览">
        <img :src="currentImg" style="margin: 0 auto; display: block; max-width: 100%" />
      </el-dialog>
    </div>
    <div class="footer">中通快递股份有限公司©2002-2022</div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, reloadUrl, useCurrentAppInstance, onMounted } from '@zto/zpage'

enum LoginMode {
  PASSWORD = 1, // 密码登录
  SMS = 2 // 短信登录
}

interface LoginModel {
  mode: LoginMode
  // username?: string
  password?: string
  mobile: string
  verifyCode?: string
  verifyId?: String
}

const app = useCurrentAppInstance()
const { Message, MessageBox } = app.useMessage()
const loginModel = ref<LoginModel>({
  mode: LoginMode.SMS,
  // username: '',
  password: '',
  mobile: '',
  verifyCode: '',
  verifyId: ''
})
const androidImg = 'https://fscdn.zto.com/fs41/M01/8E/D6/CgRRbWapmLOAezCUAAA1vSjS_k4868.png'
const iosImg = 'https://fscdn.zto.com/fs8/M00/74/97/CgRUnWapmLeAWVpcAADbdKvbDuw577.png'
let dialogVisible = ref(false)
let currentImg = ref('')
function handlePreview(url: string) {
  console.log('fuck')
  currentImg.value = url
  dialogVisible.value = true
}
function startVerify() {
  ;(window as any).secVerify.popupVerify(
    { appid: app.env.appId, eventType: 'login' }, // 这里的appid请提供高峰期用量后, 向 @张肖辉 索取, eventType为业务方定义
    function (result: any) {
      const { passed, verifyId } = result
      if (passed) {
        loginModel.value.verifyId = verifyId
        handleVerifyCode()
      }
    }
  )
}
function changeLoginMode(mode: LoginMode) {
  loginModel.value.mode = mode
}

const verifyText = ref('获取验证码')

async function handleVerifyCode() {
  if (!isPhone(loginModel.value.mobile)) {
    Message.error('请先输入正确的手机号')
    return
  }
  let n = 59
  verifyText.value = n + '秒'
  const timer = setInterval(() => {
    if (n <= 1) {
      verifyText.value = '获取验证码'
      clearInterval(timer)
    } else {
      n--
      verifyText.value = n + '秒'
    }
  }, 1000)

  const mobile = loginModel.value.mobile
  if (!mobile) return
  await app.apis.authApi.sendVerifyCode(loginModel.value)
}

function isPhone(phone: string) {
  const mobilereg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  return mobilereg.test(phone)
}

function handleLogin() {
  // alert(JSON.stringify(loginModel.value))
  if (!isPhone(loginModel.value.mobile)) {
    Message.error('请输入正确的手机号')
    return
  }
  if (loginModel.value.mode === LoginMode.PASSWORD) {
    if (!loginModel.value.password || loginModel.value.password?.length < 8) {
      Message.error('请输入正确的密码')
      return
    }
  }
  if (loginModel.value.mode === LoginMode.SMS) {
    if (!loginModel.value.verifyCode || loginModel.value.verifyCode?.length !== 6) {
      Message.error('请输入正确的验证码')
      return
    }
  }

  doLogin()
}

/** 执行登录 */
async function doLogin() {
  await app.apis.authApi.login(loginModel.value)

  reloadUrl(window.location.origin)
}

const APP_TITLE = ref()
onMounted(() => {
  if (window && window.location) {
    if (window.location.href.indexOf('terminal-admin') > -1) {
      APP_TITLE.value = '兔网通终端管理系统'
    } else if (window.location.href.indexOf('agent-admin') > -1) {
      APP_TITLE.value = '兔网通合作商管理系统'
    }
  }
})

const isProd = computed(() => {
  if (window && window.location) {
    if (
      window.location.href.indexOf('terminal-admin.tuxi.com') > -1 ||
      window.location.href.indexOf('agent-admin.tuxi.com') > -1
    ) {
      return true
    }
    return false
  }
  return false
})
</script>

<style lang="scss" scoped>
.login-container {
  .img-ios,
  .img-android {
    position: absolute;
    bottom: 10px;
    width: 100px;
    height: 100px;
  }
  .img-ios {
    left: 400px;
  }
  .img-android {
    left: 550px;
  }
  .login_header {
    height: 90px;
    background-color: #fff;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    padding-left: 40px;

    .logo {
      width: 64px;
      height: 64px;
    }

    .app-name {
      font-size: 22px;
      font-weight: 800;
      vertical-align: middle;
      color: #1890ff;
      margin-left: 10px;
    }
  }

  .login_bg {
    position: relative;
    width: 100%;
    background-size: cover;
    background-position: 50%;
    padding-top: 8%;
    padding-bottom: 8%;
    -webkit-flex: 1 1 auto;
    flex: 1 1 auto;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    -webkit-align-items: center;
    align-items: center;
  }

  .login_modal {
    position: relative;
    width: 400px;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    background: #fff;
    margin-right: 12%;

    .login-content {
      padding: 36px 40px 25px;
      box-sizing: border-box;

      .tabs-nav {
        padding: 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;

        .nav-item {
          cursor: pointer;

          &.active {
            font-weight: bold;
          }

          span {
            margin: 0 32px 0 0;
            font-size: 24px;
            color: #1890ff;
          }
        }
      }

      .login-group {
        margin-top: 40px;

        .input {
          margin-bottom: 20px;
        }

        .el-input__inner {
          //height: 48px;
        }
      }

      .login-footer {
        width: 100%;
        margin-top: 20px;
        margin-bottom: 24px;

        .el-button {
          width: 100%;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }

  .footer {
    line-height: 80px;
    color: #606266;
    font-size: 14px;
    width: 100%;
    bottom: 0;
    text-align: center;
  }
}
</style>
